import { j as e } from "../../../../node_modules/react/jsx-runtime.js";
import a from "../../CompactButton/CompactButton.js";
import l from "../../Flex/Flex.js";
import { Typography as c } from "../../Typography/Typography.js";
import f from "../Calender.module.scss.js";
import { prevMonth as p, nextMonth as x } from "../calender.helper.js";
import d from "../../Icon/Icon.js";
import { clsx as h } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { getLocale as g, formatDate as v } from "../../../../utils/helper.js";
const N = ({ onChange: o, currentMonth: s, month: m, onClick: t, type: r = "single" }) => {
  const n = g();
  return /* @__PURE__ */ e.jsxs("div", { className: f.header, children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        "data-testid": "year-select",
        className: h("flex items-center justify-between gap-075", {
          "cursor-pointer": r === "single"
        }),
        onClick: () => {
          r === "single" && t();
        },
        role: "button",
        tabIndex: 0,
        onKeyDown: (i) => {
          i.key === "Enter" && (i.preventDefault(), t == null || t());
        },
        children: [
          /* @__PURE__ */ e.jsx(
            c,
            {
              text: v(m, "MMMM yyyy"),
              variant: "interface/strong/m",
              textColor: "color/fg/bold"
            }
          ),
          r === "single" && /* @__PURE__ */ e.jsx(
            d,
            {
              name: "chevron-down",
              size: "md"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs(
      l,
      {
        itemsCenter: !0,
        className: "gap-100",
        children: [
          /* @__PURE__ */ e.jsx(
            a,
            {
              variant: "ghost",
              size: "small",
              icon: n === "en" ? "chevron-left" : "chevron-right",
              onClick: () => p(s, o),
              testId: "prev-month"
            }
          ),
          /* @__PURE__ */ e.jsx(
            a,
            {
              variant: "ghost",
              size: "small",
              icon: n === "en" ? "chevron-right" : "chevron-left",
              onClick: () => x(s, o),
              testId: "next-month"
            }
          )
        ]
      }
    )
  ] });
};
export {
  N as default
};
//# sourceMappingURL=Header.js.map
